import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Well, Button } from 'react-bootstrap';
const env = process.env;

class SectionPreview extends Component {
  render() {
    const { size, section } = this.props;
    return (
      <Col xs={size || 12}>
        <Well>
          {section.title || <a><i className="fa fa-plus"></i> Add Section</a>}
        </Well>
      </Col>
    )
  }
}

/** Takes 2 props: sections and order **/
class SectionOrderer extends Component {
  static propTypes = {
    sections: PropTypes.array,
    order: PropTypes.array,
    columns: PropTypes.number //States what the order base should be. 12 columns by default
  }
  render() {
    const { sections, order, columns } = this.props;
    if(!sections || !order) return null;
    const orderBase = columns || 12;
    const sectionsInOrder = [...sections];
    return (
      <Row>
        {order.map((size, idx) => {
          const section = sectionsInOrder.shift();
          return <SectionPreview key={section ? section._id : `${size}-${idx}`} size={size} section={section} />
        })}
        {sectionsInOrder.map(section => section ? (
          <SectionPreview key={section._id} size={12} section={section} />
        ) : null)}
      </Row>
    )
  }
}

export default SectionOrderer;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/section-orderer.js